// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueResource from 'vue-resource'
import VuexI18n from 'vue-i18n'
import { setLocalStore, getLocalStore } from '@/lib/mUtils'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import moment from 'moment'

Vue.use(VueResource)
Vue.use(VuexI18n)
Vue.use(ElementUI)
Vue.prototype.$moment = moment

const i18n = new VuexI18n({
  locale: 'zh-CN',
  messages: {
    'zh-CN': require('./i18n/zh-CN'),
    'zh-TW': require('./i18n/zh_TW'),
    'en-US': require('./i18n/en-US')

  }
})

Vue.config.productionTip = false
process.env.NODE_ENV !== 'development' && (axios.defaults.baseURL = 'https://cx.istemedu.com/')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  i18n,
  components: { App },
  created() {
    this.initLanguage()
  },
  mounted() {
      // (function(m, ei, q, i, a, j, s) {
      //     m[i] = m[i] || function() {
      //         (m[i].a = m[i].a || []).push(arguments)
      //     }
      //     j = ei.createElement(q)
      //     s = ei.getElementsByTagName(q)[0]
      //     j.async = true
      //     j.charset = 'UTF-8'
      //     j.src = 'https://static.meiqia.com/dist/meiqia.js?_=t'
      //     s.parentNode.insertBefore(j, s)
      // })(window, document, 'script', '_MEIQIA')
      // _MEIQIA('entId', 47410)     // eslint-disable-line
      // _MEIQIA('allSet', () => {   // eslint-disable-line
      //   console.log('客服初始化成功')
      // })
  },
  methods: {
    initLanguage() {
      let language = getLocalStore('vue-language') || (navigator.browserLanguage ? navigator.browserLanguage : navigator.language)
      if (['en-US', 'zh-CN', 'zh-TW'].indexOf(language) === -1) {
        console.warn('国际化异常:%s', language)
        language = 'zh-CN'
      }
      this.$i18n.locale = language
      setLocalStore('vue-language', language)
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js